import React from "react";
import styles from "./PFSMarketRetrievers.module.css";
import ContentContainer from "../ContentContainer/ContentContainer";
import MRCLogo from "./MRC-Logo-Stacked.png";
import { NavLink, useLocation } from "react-router-dom";
import { useBreadcrumb } from "../../hooks/useBreadcrumb";
import { PartnersIndexBreadcrumb } from "../PFSPartnersIndex/PFSPartnersIndex";

const PFSMarketRetrievers = () => {
  const { pathname } = useLocation();

  useBreadcrumb([
    PartnersIndexBreadcrumb,
    {
      label: 'Market Retrievers',
      url: pathname,
    },
  ]);

  return (
    <div className={styles.PfsMarketRetrievers} data-testid="PFSMarketRetrievers">
      <ContentContainer>
        <img className={styles.logo} src={MRCLogo} alt="Market Retrievers Logo" />
        <h1>Market Retrievers joins PFS Global as a Partner!</h1>
        <div className={styles.content}>
          <p>
            Market Retrievers is a boutique marketing agency offering a full marketing team for your business
            without the costs of staffing and hassles of training. The Market Retrievers team has over 35
            years of combined experience working with insurance agencies, insurance companies, trade
            associations, nonprofits, and B2B clients. We can speak the language of your clients,
            prospects, and staff to develop marketing strategies that will drive business,
            engagement, and help you <em><strong>FETCH</strong> YOUR TARGETS.</em>
          </p>
          <p>
            For more information about Market Retrievers, please visit{' '}
            <a href="https://www.marketretrievers.com" target="_blank" rel="noopener noreferrer">
              www.marketretrievers.com
            </a>.
          </p>
          <NavLink to={'/who-we-trust'} id={styles.homeBtn}>
            Back to Who We Trust
          </NavLink>
        </div>
      </ContentContainer>
    </div>
  );
};

export default PFSMarketRetrievers;
